import styled from 'styled-components'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'

const PortraitPrintPageDiv = styled.div`
  width: 210mm;
  padding: 10mm 10mm 0mm 10mm;
  font-family: "ipag";
  overflow-wrap: anywhere;
`

const PageDiv = styled(PortraitPrintPageDiv)`
  font-size: 10pt;
`

export const FirstPageDiv = PageDiv

export const NextPageDiv = styled(PageDiv)`
    break-before: page;
`


const PortraitPrintHeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 190mm;
`

export const HeaderArea = styled(PortraitPrintHeaderArea)`
  font-size: 10pt;
`

export const HeaderAreaBox: StyledDiv = styled.div`
  display: flex;
`

export const ApplyTitle: StyledDiv = styled.div`
  font-size: 14pt;
  font-weight: 700;
`

const ContractPageDiv = styled(PortraitPrintPageDiv)`
  font-size: 9pt;
  line-height: 1.5;
`

export const FirstContractPageDiv = ContractPageDiv

export const NextContractPageDiv = styled(ContractPageDiv)`
  break-before: page;
`

export const ContractHeaderArea: StyledDiv = styled(PortraitPrintHeaderArea)`
  font-size: 9pt;
`

export const ContractApplyTitle: StyledDiv = styled.div`
  font-size: 13pt;
  font-weight: 700;
`

export const ContractBodyArea: StyledDiv = styled.div`
  width: 170mm;
`

export const PageDivForLandscape: StyledDiv = styled.div`
  width: 297mm;
  padding: 20mm 20mm 0mm 20mm;
  font-size: 22pt;
  font-family: "ipag";
  overflow-wrap: anywhere;
`

export const HeaderAreaForLandscape: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 34pt;
`

export const ApplyTitleForLandscape: StyledDiv = styled.div`
  font-size: 34pt;
  font-weight: 700;
`

export const PrintContentArea = styled.div`
    display: none;
`
